var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { P, PCSS, CustomElement, Defaults, ViewChild } from '@pacem/pacem-core';
import { PacemTextualInputElement } from './input';
//namespace Pacem.Components.Scaffolding {
let PacemSearchInputElement = class PacemSearchInputElement extends PacemTextualInputElement {
    constructor() {
        super();
    }
    get inputFields() {
        return [this.input];
    }
    toggleReadonlyView(readonly) {
        // no readonly view provided.
    }
};
__decorate([
    ViewChild('input[type=search]')
], PacemSearchInputElement.prototype, "input", void 0);
PacemSearchInputElement = __decorate([
    CustomElement({ tagName: P + '-input-search', template: '<input type="search" class="' + PCSS + '-input" />', shadow: Defaults.USE_SHADOW_ROOT })
], PacemSearchInputElement);
export { PacemSearchInputElement };
